import { useEffect, useMemo } from 'react';
import { useStore } from 'store/store';
import { useUtxFeeCalcFeeForUser } from '../../../../../packages/utx-client/src/react';
import { ErrorCode } from '../enum';

export interface UseGetCalcFeeProp {
  billPaymentData: {
    fee: any;
    isLoading: boolean;
    refetch: () => void;
  };
}

export interface UseBillPaymentParams {
  enabledFetchBillPaymentFee?: boolean;
  amount?: string;
  assetSymbol?: string;
}

export const useBillPaymentCalcFee = (params: UseBillPaymentParams): UseGetCalcFeeProp => {
  const store = useStore();
  const { enabledFetchBillPaymentFee, amount, assetSymbol } = params;
  // GET Fee
  const queryBillPaymentFee = useUtxFeeCalcFeeForUser(
    {
      intent: 'BILL_PAYMENT',
      policy_name: 'general_instruction',
      amount: amount ?? '',
      asset_symbol: assetSymbol ?? '',
      objectId: '',
      locale: 'en-US'
    },
    {
      query: {
        enabled: enabledFetchBillPaymentFee !== undefined ? enabledFetchBillPaymentFee : true
      },
      axios: {
        headers: {
          Authorization: `Bearer ${store.authToken}`
        }
      }
    }
  );

  const billPaymentFeeData = useMemo(() => {
    const data = queryBillPaymentFee.data?.data;
    return data;
  }, [queryBillPaymentFee.data?.data]);

  const isLoadingBillPaymentFee = useMemo(() => {
    return queryBillPaymentFee.isLoading;
  }, [queryBillPaymentFee.isLoading]);

  useEffect(() => {
    if (queryBillPaymentFee.error) {
      var statusCode: number | undefined = queryBillPaymentFee.error.response?.status;
      if (statusCode !== ErrorCode.EXPIRED_TOKEN_ERROR) {
        queryBillPaymentFee.refetch();
      }
    }
  }, [queryBillPaymentFee.error]);

  const refetchBillPaymentFee = () => {
    queryBillPaymentFee.refetch();
  };

  return {
    billPaymentData: {
      fee: billPaymentFeeData,
      isLoading: isLoadingBillPaymentFee,
      refetch: refetchBillPaymentFee
    }
  };
};
